export enum TourPlanOtherContentCategoryTypes {
  SERVICES = 'Services',
  VISA = 'Visa',
  GENERAL_CONDITIONS = 'GeneralConditions',
  COVID_PRECAUTIONS = 'CovidPrecautions',
}
